import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { JourneyShell } from "@/components/journey/JourneyShell";
import { useJourneyContent } from "@/hooks/useJourneyContent";
import { getAccount, reportDownloadUrl } from "@/lib/journeyApi";
import "@/pages/Journey.css";

export default function ReportReady() {
  const { ui, loading } = useJourneyContent();
  const [report, setReport] = useState(null);

  useEffect(() => {
    let active = true;
    getAccount().then((data) => {
      if (active) setReport(data.reports.find((item) => item.kind === "free") || null);
    });
    return () => { active = false; };
  }, []);

  if (loading || !ui || !report) return <div className="journey-loading" data-testid="report-ready-loading-state" />;
  return (
    <JourneyShell>
      <section className="journey-panel" data-testid="report-ready-panel">
        <h1 data-testid="report-ready-title">{ui.free_ready.title}</h1>
        <a className="journey-primary journey-download" href={reportDownloadUrl(report.report_id)} data-testid="free-report-download-link">
          <Download aria-hidden="true" /> {ui.free_ready.download}
        </a>
        <div className="journey-divider" />
        <h2 data-testid="report-next-title">{ui.free_ready.next_title}</h2>
        <p data-testid="report-next-body">{ui.free_ready.next_body}</p>
        <Link className="journey-secondary" to="/screen" data-testid="continue-to-screen-link">{ui.free_ready.next_button}</Link>
      </section>
    </JourneyShell>
  );
}